<template>
  <div class="profile-input-wrapper">
    <profile-form ref="form" endpoint="waterpreference" @error="$emit('done', $event)">
      <form class="form">
        <fieldset>
          <legend class="sr-only">{{ inputTitle }}</legend>
          <span class="profile-input-label">{{ listLabel }}</span>
          <div class="input radio">
            <label v-for="type in waterTypes" :key="type.value">
              <input
                v-model="waterPreferenceId"
                type="radio"
                name="waterPreference"
                :id="type.value"
                :value="type.value"
                data-val="true"
                :data-val-required="getValidationForField('required', 'waterPreference')"
              />
              {{ type.label }}
            </label>
            <span
              data-valmsg-for="waterPreference"
              data-valmsg-replace="true"
              class="field-validation-valid"
            ></span>
          </div>
          <input type="hidden" :value="true" name="isWaterPreference" />
        </fieldset>
      </form>
    </profile-form>
  </div>
</template>

<script>
  import ProfileInputMixin from '@mixins/profile-input-mixin'

  export default {
    name: 'profile-water-preference-input',
    mixins: [ProfileInputMixin],
    props: {
      waterTypes: {
        type: Array,
        required: true
      },
      listLabel: {
        type: String
      }
    },
    data: () => ({
      localProfile: {
        waterPreference: [],
      }
    }),
    computed: {
      waterPreferenceId: {
        get() {
          const selectedWaterType = this.waterTypes.find(
            (el) => this.localProfile.waterPreference
              .some((preference) => preference.value === el.value)
          )
          return selectedWaterType?.value
        },
        set(value) {
          const waterType = this.waterTypes.find((el) => el.value === value)
          this.localProfile.waterPreference = [waterType]
        }
      }
    }
  }
</script>
